import { cn } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { useExperienceContext } from '../Experience';
import { SchoolPartnerLogo } from '../Experience/SchoolPartner';

interface Props {
  className?: string;
  height: number;
}

function ExperienceViewLogo({ height, className }: Props) {
  const { experienceResource } = useExperienceContext();

  return (
    <div
      className={cn(
        'box-border flex h-full w-full items-center justify-center bg-[#e1e1e1] p-2',
        className,
      )}
    >
      <SchoolPartnerLogo data={experienceResource.payload.schoolPartner} height={height} />
    </div>
  );
}

export default observer(ExperienceViewLogo);
